module.exports = __webpack_public_path__ + "static/media/3.652ed974.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/cats/3.jpg
// module id = 208
// module chunks = 0